const COLORS = {
  primary: "#811C50",
  primaryLight: "#811C5010", // For hover background
  borderDefault: "border-gray-400",
  iconDefault: "text-gray-500",
  borderFocus: "border-[#811C50]",
  iconFocus: "text-[#811C50]",
  textBlack: "text-black",
  textWhite: "text-white",
    delete: "#FF4D4F",
};

export default COLORS;
